import { useEffect } from 'react';
import { useHeader } from '../../Providers/HeaderContextProvider';
import arisLogo from '../../Assets/icon/aris_logo.svg';
import './style.css';

const AuthLayout = ({ children, showBackButton = false, onBack = null }) => {
  const { setHeaderContent } = useHeader();

  useEffect(() => {
    setHeaderContent(false);
  }, [setHeaderContent]);

  return (
    <div className="auth-layout-container">
      <div className="auth-layout-wrapper">
        {showBackButton && onBack && (
          <button className="auth-back-button" onClick={onBack}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back
          </button>
        )}
        
        <div className="auth-layout-header">
          <img src={arisLogo} alt="Aris" className="auth-layout-logo" />
        </div>

        <div className="auth-layout-content">
          {children}
        </div>

        <div className="auth-layout-footer">
          <p>© 2026 Aristotle, Inc. All rights reserved. Patents pending.</p>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
